import { Dispatch } from "redux";
import axios from "axios";
import {QuickbetXTrackingAction, QuickbetXTrackingActionTypes} from "../../types/QuickbetX/quickbetXTrackingTypes";

interface ErrorResponse {
    code: number;
    message: string;
}

export const trackingQuicktipX = (code: string): any => {
    return async (dispatch: Dispatch<QuickbetXTrackingAction>) => {
        try {
            dispatch({ type: QuickbetXTrackingActionTypes.FETCH_QUICKBET_X_TRACKING_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/tickets/${code}`,
                withCredentials: false
            });
            dispatch({ type: QuickbetXTrackingActionTypes.FETCH_QUICKBET_X_TRACKING_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuickbetXTrackingActionTypes.FETCH_QUICKBET_X_TRACKING_DATA_ERROR, payload: errorPayload });
        }
    }
}
